import { createDataHooks } from '@wix/premium-fed-sdk/test-utils';
export const TldPromotionBoxDataHooks = createDataHooks('tld-promotion-box', 'badge', 'infoIcon');
//# sourceMappingURL=dataHooks.js.map